import type { FC, PropsWithChildren } from "react";
import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";
import { WarningIcon } from "../Icons";

export const Warning: FC<PropsWithChildren<Styled>> = ({
  children,
  className,
}) => (
  <div
    className={twMerge(
      "flex gap-4 rounded-xl bg-warning-90 p-4 text-left text-warning-30",
      className,
    )}
  >
    <WarningIcon className="size-6 shrink-0" />
    {children}
  </div>
);
